module.exports = __webpack_public_path__ + "static/media/Transversalidad_movil.f19029ab.png";